export default __webpack_public_path__ + "static/28001-e15106bbe8f99838d913b518a32c1786.jpg";